import { render, staticRenderFns } from "./FormDeleteTemplate.vue?vue&type=template&id=d5f3dd6a"
import script from "./FormDeleteTemplate.vue?vue&type=script&lang=js"
export * from "./FormDeleteTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports